<template>
  <div v-loading="loading" class="list-card">
    <div class="list-title">
      <span class="bullet purple-bullet"></span>
      TOP 5 HIỆN VẬT TIÊU BIỂU NỔI BẬT
    </div>
    <div class="table-container">
      <table class="rank-table">
        <thead>
          <tr>
            <th style="width: 50px; text-align: center;">#</th>
            <th>TÊN HIỆN VẬT</th>
            <th style="width: 120px;">LOẠI</th>
            <th style="width: 120px; text-align: right;">LƯỢT XEM</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(artifact, idx) in artifacts" :key="idx">
            <td style="text-align: center;">
              <span :class="['rank-badge', `rank-${idx + 1}`]">{{ idx + 1 }}</span>
            </td>
            <td class="bold-text">{{ artifact.name }}</td>
            <td style="text-align: center;">
              <span :class="['badge-tag', artifact.typeClass]">{{ artifact.type }}</span>
            </td>
            <td style="text-align: right;" class="number-text">{{ artifact.view_count | numberWithDelimiter }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getArtifacts } from '@/services/artifact'

export default {
  name: 'TopArtifactsTable',
  filters: {
    numberWithDelimiter(val) {
      if (val === undefined || val === null) return '0'
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    }
  },
  data() {
    return {
      artifacts: [],
      loading: false
    }
  },
  computed: {
    ...mapGetters(['language'])
  },
  created() {
    this.fetchTopArtifacts()
  },
  methods: {
    getPseudoViews(id) {
      if (!id) return 0
      let hash = 0
      for (let i = 0; i < id.length; i++) {
        hash = id.charCodeAt(i) + ((hash << 5) - hash)
      }
      return Math.abs(hash % 20000) + 1200
    },
    getArtifactTypeClass(type) {
      const colors = ['badge-purple', 'badge-green', 'badge-magenta', 'badge-orange', 'badge-cyan']
      if (type === 'Khảo cổ') return 'badge-purple'
      if (type === 'Tôn giáo') return 'badge-green'
      if (type === 'Mỹ thuật') return 'badge-magenta'
      if (type === 'Lịch sử') return 'badge-orange'
      if (type === 'Dân gian') return 'badge-cyan'
      const index = type.charCodeAt(0) % colors.length
      return colors[index]
    },
    fetchTopArtifacts() {
      this.loading = true
      const locale = this.language || (this.$i18n && this.$i18n.locale) || localStorage.getItem('language') || 'vi'
      const params = {
        page: 1,
        per_page: 5,
        locale
      }
      getArtifacts(params).then((response) => {
        if (response && response.result) {
          this.artifacts = response.result.map((item) => {
            const typeName = item.classification ? (item.classification.summary || item.classification.name || 'Khảo cổ') : 'Khảo cổ'
            return {
              id: item.id,
              name: item.name,
              type: typeName,
              typeClass: this.getArtifactTypeClass(typeName),
              views: this.getPseudoViews(item.id)
            }
          })
        }
        this.loading = false
      }).catch((err) => {
        console.error('Failed to fetch top artifacts', err)
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.list-card {
  background: #ffffff;
  border-radius: 10px;
  padding: 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
  box-sizing: border-box;

  .list-title {
    font-size: 13px;
    font-weight: 700;
    color: #2c3e50;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    text-transform: uppercase;
    letter-spacing: 0.3px;

    .bullet {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      margin-right: 10px;
    }
    .purple-bullet { background-color: #8a2be2; }
  }
}

.table-container {
  width: 100%;
  overflow-x: auto;
}

.rank-table {
  width: 100%;
  border-collapse: collapse;

  th {
    padding: 12px 10px;
    font-size: 11px;
    font-weight: 700;
    color: #7f8c8d;
    border-bottom: 2px solid #f1f1f1;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    white-space: nowrap;
  }

  tr {
    border-bottom: 1px solid #f9f9f9;
    transition: background-color 0.2s;

    &:hover {
      background-color: #f9fbfd;
    }
  }

  td {
    padding: 14px 10px;
    font-size: 13px;
    color: #2c3e50;
    vertical-align: middle;
  }

  .bold-text {
    font-weight: 600;
    color: #34495e;
  }

  .number-text {
    font-weight: 700;
    font-family: 'Courier New', Courier, monospace;
    font-size: 14px;
    color: #2c3e50;
  }
}

.rank-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  font-size: 12px;
  font-weight: 800;
  color: #fff;

  &.rank-1 { background-color: #f39c12; }
  &.rank-2 { background-color: #bdc3c7; }
  &.rank-3 { background-color: #d35400; }
  &.rank-4, &.rank-5 {
    background-color: #ebf5fb;
    color: #2980b9;
    font-weight: 600;
  }
}

.badge-tag {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;

  &.badge-purple { background-color: #ebd7f7; color: #8a2be2; }
  &.badge-green { background-color: #e2f9eb; color: #27ae60; }
  &.badge-magenta { background-color: #fce8f3; color: #d81b60; }
  &.badge-orange { background-color: #fef5e7; color: #d35400; }
  &.badge-cyan { background-color: #e0f7fa; color: #00838f; }
}
</style>
